import axios from "axios";

// export const apiURL = "http://localhost:8080/Development/rite-account-backend/";
export const apiURL = "https://riteaccount.com/backend/";

const axiosInstance = axios.create({
  baseURL: apiURL,
});

export function fetchPlanDetail(data) {
  return axiosInstance.post("plandetail.php", data);
}

export function fetchPartnershipDetail(data) {
  return axiosInstance.post("partnershipdetail.php", data);
}

export function fetchNewsletterDetail(data) {
  return axiosInstance.post("newsletterdetail.php", data);
}

export function fetchBookingDetail(data) {
  return axiosInstance.post("bookingdetail.php", data);
}

export function fetchcontactusdetail(data) {
  return axiosInstance.post("contactusdetail.php", data);
}
